export const LoginBackgroundIllustrations = () => {
  return (
    <svg
      width="90%"
      height="90%"
      viewBox="0 0 1281 858"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="-372.5"
        cy="306.056"
        r="551"
        stroke="#6F6259"
        strokeDasharray="2 3"
      />
      <circle
        cx="729.5"
        cy="306.056"
        r="551"
        stroke="#6F6259"
        strokeDasharray="2 3"
      />
      <circle cx="180" cy="298" r="24" fill="#6F6259" />
      <path
        d="M176.938 287.196L186.814 297.98L176.938 308.764"
        stroke="#FAF4E5"
        strokeWidth="4"
        strokeLinejoin="bevel"
      />
    </svg>
  )
}
